import { MCS_COLOR } from 'modules/editor/components/CoverageLegend/constants';

export const getPositionByMcs = (mcs: number) => {
  if (mcs < 3) {
    return mcs * 0.11;
  }
  if (mcs < 7) {
    return 0.33 + (0.33 / 4) * (mcs - 3);
  }
  return 0.66 + (0.33 / 7) * (mcs - 7);
};

const gradientColors = Object.keys(MCS_COLOR).map((key) => {
  const numKey = Number(key) as keyof typeof MCS_COLOR;
  let percent = getPositionByMcs(numKey) * 100;
  if (numKey < 2) {
    percent = 3 * numKey;
  }
  return `${MCS_COLOR[numKey]} ${percent}%`;
});

export const gradientStyle = {
  background: `linear-gradient(to right, ${gradientColors.join(',')})`,
};
